var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _path6, _path7, _path8, _path9, _path10, _rect3, _path11, _rect4, _rect5, _ellipse, _path12, _g, _g2, _path13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoVentilation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 246,
    viewBox: "0 0 115 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.8557 233.588V224.621C74.8557 223.517 73.9603 222.621 72.8557 222.621H16.7076C15.6031 222.621 14.7076 223.517 14.7076 224.621V233.588",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4758 233.428V231.449C12.4758 230.029 11.3242 228.877 9.90366 228.877C8.48312 228.877 7.33154 230.029 7.33154 231.449V242.925C7.33154 244.345 8.48312 245.497 9.90366 245.497C11.3242 245.497 12.4758 244.345 12.4758 242.925V242.529C12.4758 241.109 13.6274 239.957 15.0479 239.957C16.4684 239.957 17.62 241.109 17.62 242.529V243.321C17.62 244.523 18.5944 245.497 19.7964 245.497C20.9984 245.497 21.9728 244.523 21.9728 243.321V231.054C21.9728 229.852 20.9984 228.877 19.7964 228.877C18.5944 228.877 17.62 229.852 17.62 231.054V233.428C17.62 234.848 16.4684 236 15.0479 236C13.6274 236 12.4758 234.848 12.4758 233.428Z",
    fill: "white",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6237 233.428V231.449C72.6237 230.029 71.4722 228.877 70.0516 228.877C68.6311 228.877 67.4795 230.029 67.4795 231.449V242.925C67.4795 244.345 68.6311 245.497 70.0516 245.497C71.4722 245.497 72.6237 244.345 72.6237 242.925V242.529C72.6237 241.109 73.7753 239.957 75.1959 239.957C76.6164 239.957 77.768 241.109 77.768 242.529V243.321C77.768 244.523 78.7424 245.497 79.9444 245.497C81.1464 245.497 82.1208 244.523 82.1208 243.321V231.054C82.1208 229.852 81.1464 228.877 79.9444 228.877C78.7424 228.877 77.768 229.852 77.768 231.054V233.428C77.768 234.848 76.6164 236 75.1959 236C73.7753 236 72.6237 234.848 72.6237 233.428Z",
    fill: "white",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3196 159.046L45.3196 218.564",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3196 76.011L45.3196 94.2881",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "square"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.4114,
    y: 35,
    width: 49.2999,
    height: 38.6399,
    rx: 3,
    stroke: "white",
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.4114,
    y: 79.8875,
    width: 53.2999,
    height: 70.1782,
    rx: 5,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0615 97.0247L59.8381 87.3619C60.0917 87.0657 60.7158 86.6733 61.1839 87.4729L62.3541 92.0822L65.0456 90.5273C65.4162 90.3792 66.1222 90.2941 65.9818 91.1382L64.5775 95.5253C64.3825 95.9326 63.8286 96.5027 63.1733 95.5253L62.3541 92.0822L51.9392 97.9688C51.5296 98.0614 50.7806 98.0021 51.0615 97.0247Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6333 54.9159H73.2245C73.4122 54.9159 73.5841 54.8107 73.6696 54.6436L76.8193 48.4857C77.0175 48.098 77.5822 48.1314 77.7333 48.5398L82.1098 60.3612C82.2444 60.7247 82.7234 60.8035 82.9673 60.5023L87.4915 54.9159",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6333 49.1498H73.2245C73.4122 49.1498 73.5841 49.0446 73.6696 48.8775L76.8193 42.7195C77.0175 42.3319 77.5822 42.3653 77.7333 42.7736L82.1098 54.5951C82.2444 54.9586 82.7234 55.0374 82.9673 54.7362L87.4915 49.1498",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0315 58.3959H46.1062C46.3154 58.3959 46.5024 58.2656 46.5751 58.0695L50.9829 46.1633C51.1524 45.7055 51.8102 45.737 51.9352 46.2088L56.6512 64.0149C56.7738 64.4777 57.414 64.5202 57.5967 64.0777L62.403 52.4363C62.4803 52.2491 62.6627 52.1271 62.8652 52.1271H73.2245C73.4122 52.1271 73.5841 52.0219 73.6696 51.8547L76.8193 45.6968C77.0176 45.3092 77.5822 45.3426 77.7333 45.7509L82.1098 57.5724C82.2444 57.9359 82.7234 58.0147 82.9673 57.7135L87.4915 52.1271",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8401 147.979C83.2928 143.665 86.8717 137.124 86.4383 133.07C86.2961 131.74 84.9538 131.062 83.6164 131.062H5.62881C3.9932 131.062 2.46352 132.061 2.28832 133.687C1.81517 138.079 3.75045 144.561 14.0044 147.979",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 151.424,
    width: 87,
    height: 5.6129,
    rx: 2.80645,
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0317 127.66H61.7414C62.2937 127.66 62.7414 128.108 62.7414 128.66V143.499C62.7414 144.051 62.2937 144.499 61.7414 144.499H15.0317V127.66Z",
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 50.7466,
    y: 172.563,
    width: 16.8387,
    height: 16.8387,
    rx: 3,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24.0964,
    y: 175.369,
    width: 16.8387,
    height: 19.6452,
    rx: 3,
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.0638,
    cy: 136.079,
    rx: 5.6129,
    ry: 5.6129,
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2099 136.079C47.2099 138.351 45.3685 140.192 43.097 140.192C40.8255 140.192 38.9841 138.351 38.9841 136.079C38.9841 133.808 40.8255 131.966 43.097 131.966C45.3685 131.966 47.2099 133.808 47.2099 136.079Z",
    stroke: "white",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7127_3150)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_7127_3150)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 37.5,
    r: 22,
    fill: "#6D1DF0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 37.5,
    r: 20,
    stroke: "white",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91 24L64 51",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_7127_3150)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_7127_3150)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 37.5,
    r: 24.5,
    stroke: "black",
    strokeWidth: 6
  })))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M62.75 37.5802H69.875L73.5264 27.5128C73.6217 27.2501 74.0379 27.2521 74.1299 27.5157L81.4422 48.4521C81.5353 48.7186 81.9576 48.7168 82.0477 48.4494L85.7083 37.5802H91.25",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7127_3150",
    x: 45.5,
    y: 5.5,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7127_3150"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7127_3150",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_7127_3150",
    x: 25.5,
    y: -14.5,
    width: 104,
    height: 104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_7127_3150"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_7127_3150",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_7127_3150",
    x: 40,
    y: 0,
    width: 75,
    height: 75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7127_3150"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7127_3150",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_7127_3150",
    x: 20,
    y: -20,
    width: 115,
    height: 115,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_7127_3150"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_7127_3150",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoVentilation);
export default __webpack_public_path__ + "static/media/no-ventilation.9c25bda8c37219f0336aa440bf0db995.svg";
export { ForwardRef as ReactComponent };